import { createAsyncThunk, createSlice, original } from "@reduxjs/toolkit";
import { JOB_SERVER_URL } from "../../config";
import http from "../../net/http-common";
import { isAxiosError } from "axios";
import { errorMessages } from "../../common_variables/ErrorMsgs";
import { setGlobalMsgAlerts } from "../../components/GloablMsgAlerts/globalMsgAlertsSlice";
interface stateType {
  status: string;
  properties: {
    autoDockdata: any;
    loading: boolean;
    id: number;
    evaluationIds : any[];
    ligand_url: string;
    SMILES: string;
    Docking_Score: number;
    task_id: string;
  };
}

const initialState: stateType = {
  status: "idle",
  properties: {
    autoDockdata: [],
    loading: false,
    id: -1,
    evaluationIds : [],
    ligand_url: "",
    SMILES: "",
    Docking_Score: 0,
    task_id: "",
  },
};

// get autodock properties
export const fetchAutoDockProperties = createAsyncThunk(
  "docking/fetchAutoDockProperties",
  async (
    { task_id, model_name }: { task_id: string; model_name?: string },
    { dispatch }
  ) => {
    // getting result for unidock if model_name is exist
    let url = "";
    if (model_name) {
      url = `${JOB_SERVER_URL}/dock/results?task_id=${task_id}&model_name=${model_name}&as_file=false`;
    } else {
      url = `${JOB_SERVER_URL}/dock/results?task_id=${task_id}&as_file=false`;
    }
    return http
      .get(url)
      .then((response) => response.data)
      .catch((error) => {
        let msg: string = "";
        if (isAxiosError(error)) {
          msg = error.response?.data?.detail?.message;
        }
        dispatch(
          setGlobalMsgAlerts({
            msg: msg || errorMessages.jobResultError,
            isAlert: true,
            color: "error",
          })
        );
      });
  }
);



// export const fetchPreparedLigands = createAsyncThunk(
//   "docking/fetchPreparedLigands",
//   async (task_id: string) => {
//     return axios
//       .get(`${JOB_SERVER_URL}/dock/get_prepared_ligands?task_id=${task_id}`)
//       .then((response) => response.data)
//       .catch((error) => {
//         console.log(error);
//       });
//   }
// );

const dockingSlice = createSlice({
  name: "docking",
  initialState,
  reducers: {
    setProperties(state, action) {
      //console.log(action);
    },
    setLigandUrl(state, action) {
      state.properties.id = action.payload[0];
      state.properties.evaluationIds = action.payload[1];
      state.properties.ligand_url = action.payload[2];
      state.properties.SMILES = action.payload[3];
      state.properties.Docking_Score = action.payload[4];
    },
    setTaskId(state, action) {
      state.properties.task_id = action.payload;
    },
    updateSmilesById(state, action) {
      const { id } = action.payload;
      const sliceData = original(state.properties);
      const newSmilesData =
        sliceData.autoDockdata.results[sliceData.evaluationIds[id] - 1];
      state.properties.id = id;
      state.properties.ligand_url = newSmilesData.interaction;
      state.properties.SMILES = newSmilesData.SMILES;
      state.properties.Docking_Score = newSmilesData.Docking_Score;
    },
  },
  extraReducers: (builder) => {
    // Fetch Properties
    builder
      .addCase(
        fetchAutoDockProperties.fulfilled,
        (state: stateType, action: any) => {
          state.properties.autoDockdata = action.payload;
          state.properties.loading = false;
          // Set the task ID here when fetchAutoDockProperties is fulfilled
          state.properties.task_id = action.meta.arg;
        }
      )
      .addCase(fetchAutoDockProperties.rejected, (state, action: any) => {
        state.properties.loading = false;
      })
      .addCase(fetchAutoDockProperties.pending, (state) => {
        state.properties.loading = true;
      });
  },
});

export const { setProperties, setLigandUrl, updateSmilesById } =
  dockingSlice.actions;
export default dockingSlice.reducer;
